import { useState, useEffect } from 'react';
import { projectURL } from './utils/mockdata';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register required chart.js components
ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Utility to strip HTML from post content
const stripHTML = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const DonutPieChart = () => {
  const [mxPost, setMxPost] = useState([]);

  // Fetch top liked posts
  const maxPostCreator = async () => {
    try {
      const postPath = projectURL + "dashboard/most-liked-posts";
      const postList = await fetch(postPath, {
        headers: { "cors": "no-cors" }
      });
      const postJson = await postList.json();
      setMxPost(postJson);
    } catch (error) {
      console.error("Failed to fetch post data:", error);
    }
  };

  useEffect(() => {
    maxPostCreator();
  }, []);

  // Prepare labels (cleaned post content) and data
  const maxPostData = mxPost.map((data) => stripHTML(data.post));
  const maxPostLikeDataCount = mxPost.map((data) => data.likes);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Top 5 Post Likes (Donut Chart)',
      },
    },
  };

  const data = {
    labels: maxPostData,
    datasets: [
      {
        label: 'Likes',
        data: maxPostLikeDataCount,
        backgroundColor: [
          'rgb(255, 99, 132)',
          'rgb(54, 162, 235)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(153, 102, 255)',
        ],
      },
    ],
  };

  return <Doughnut options={options} data={data} />;
};

export default DonutPieChart;
